<template>
  <div class="pdf-wrapper">

    <div class="pdf-container d-flex justify-content-center">
      <VuePdfEmbed
        ref="pdfRef"
        :source="url"
        :page="currentPage"
        :width="pdfWidth"
        annotation-layer
        text-layer
        @loaded="onLoaded"
      />
    </div>

    <div class="pagination-controls text-center mt-3">

      <button
        class="btn btn-primary me-2"
        @click="prevPage"
        :disabled="currentPage <= 1"
      >
        Anterior
      </button>

      <span class="fw-bold">
        Página {{ currentPage }} / {{ totalPages }}
      </span>

      <button
        class="btn btn-primary ms-2"
        @click="nextPage"
        :disabled="currentPage >= totalPages"
      >
        Próxima
      </button>

    </div>

  </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed'
import 'vue-pdf-embed/dist/styles/annotationLayer.css'
import 'vue-pdf-embed/dist/styles/textLayer.css'

export default {
  components: {
    VuePdfEmbed,
  },

  props: {
    url: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      currentPage: 1,
      totalPages: 0,
      pdfWidth: 900
    }
  },

  watch: {
    url() {
      this.resetPagination()
    }
  },

  methods: {

    onLoaded(pdf) {
      this.totalPages = pdf.numPages
    },

    resetPagination() {
      this.currentPage = 1
      this.totalPages = 0
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    }

  }
}
</script>

<style scoped>

.pdf-wrapper{
  width:100%;
  height:100vh;
  display:flex;
  flex-direction:column;
}

.pdf-container{
  flex:1;
  overflow:auto;
  padding:20px;
}

.pagination-controls{
  padding:10px;
  border-top:1px solid #eee;
}

</style>
